import axios from 'axios';

const api = axios.create({
  baseURL: 'https://api.aljalab.com/api/v1',
  withCredentials: true, // إرسال كوكي المصادقة (HttpOnly) تلقائيًا مع كل طلب
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Accept-Language': 'ar',
  },
});

// التوكن لم يعد يُخزّن في JavaScript — يُرسَل تلقائيًا عبر كوكي HttpOnly.

// معالجة الأخطاء — عند انتهاء الجلسة نعيد للدخول.
// نستثني مسارات المصادقة (دخول/تسجيل/استعادة) حتى تظهر رسالة الخطأ في صفحتها
// بدل إعادة التوجيه (مثلاً: بيانات دخول غير صحيحة).
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const url: string = error.config?.url || '';
    const isAuthEndpoint = url.includes('/auth/');
    if (error.response?.status === 401 && !isAuthEndpoint) {
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
